import { useParams } from 'react-router-dom';

import { useProject } from '@/api';

/**
 * Name, code and customer for the project header, from the route's project id.
 *
 * For the pages that own a project document — Planning and Financials — this is
 * the wrong tool: they pass the document they already hold (and, on Planning,
 * must, so the rename rides the plan editor's autosave). It exists for the
 * pages that have no document of their own.
 */
export const useProjectHeaderData = () => {
  const { projectId } = useParams<{ projectId?: string }>();
  const projectQuery = useProject(projectId);

  if (projectQuery.data) {
    const { document } = projectQuery.data;
    return {
      projectName: document.name,
      projectCode: document.code,
      customerName: document.customer?.snapshot.name,
    };
  }

  return {
    // An em dash rather than a guessed name: the header should not invent one
    // while the request is in flight.
    projectName: '—',
    projectCode: undefined,
    customerName: undefined,
  };
};
